import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=1eeb89f8&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeb89f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eeb89f8')) {
      api.createRecord('1eeb89f8', component.options)
    } else {
      api.reload('1eeb89f8', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=1eeb89f8&scoped=true", function () {
      api.rerender('1eeb89f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/transfer/virtual/components/ViewForm.vue"
export default component.exports